import { Button, ConfigProvider, DatePicker, Form, Input, Modal, Select, Space, Spin, Table, Tag } from "antd";
import frFR from "antd/locale/fr_FR";
import { createRef, useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import axiosInstance from "../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../variables/constants";
import { frenchDate, frenchDateOnly, isBetweenOrEqualDate, isEqualDate, } from "../../variables/functions";
import PdfBordereau from "./components/docs/PdfBordereau";
import { CreditCardOutlined, ExclamationCircleFilled, FilePdfOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import BorderauCommissions from "../caisse/docs/BordereauCommissions";
import { displayFloorNum, displayNumbers } from "../../variables/numbersFunctions";
import DocumentHeader from "../../components/docs/DocumentHeader";
import { DocumentFooter } from "../../components/docs/DocumentFooter";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { componentToBase64 } from "../../variables/imagesFunctions";

const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

const Bordereaux = () => {
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [bordereaux, setBordereaux] = useState([]);
    const [commissions, setCommissions] = useState([]);
    const [allCommissions, setAllCommissions] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [categories, setCategories] = useState([]);
    const [intermediaires, setIntermediaires] = useState([]);
    // const [allIntermediaires, setAllIntermediaires] = useState([]);
    const [courtiers, setCourtiers] = useState([]);
    // const [selectedIntermediaire, setSelectedIntermediaire] = useState("");
    const [selectedCategorie, setSelectedCategorie] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState([]);
    const [selectedDate, setSelectedDate] = useState([]);
    const [hidden, setHidden] = useState(false);
    const [bordereauToPay, setBordereauToPay] = useState(null);
    const [openModalBorderau, setOpenModalBorderau] = useState(false);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [modePaiementForm] = Form.useForm();
    const [modePaiement, setModePaiement] = useState("");
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [loading, setLoading] = useState(false);

    const printRecu = createRef();

    const printReference = useRef();

    const columns = [
        {
            title: "N° bordereau",
            dataIndex: "numeroBordereau",
            key: "numeroBordereau",
        },
        {
            title: "Apporteur",
            dataIndex: "agence",
            key: "agence",
            render: (_, record) => (
                <>{record.agence?.nom}</>
            )
        },
        {
            title: "Montant",
            dataIndex: "montant",
            key: "montant",
            render: (_, record) => (
                <>{displayNumbers(
                    Math.trunc(record.montantTotal)
                )} </>
            ),
        },
        {
            title: "Mode de paiement",
            dataIndex: "modePaiement",
            key: "modePaiement",
            render: (_, record) => (
                <>{record.modePaiement === "ESPECES" ? <Tag color='blue'>ESPECES</Tag> : record.modeReglement === "RISTOURNE" ? <Tag color='green'>RISTOURNE</Tag> : record.modeReglement && record.modeReglement !== "-" ? <Tag color='yellow'>{record.modeReglement}</Tag> : null} </>
            ),
        },
        {
            title: "Date paiement commission",
            dataIndex: "datePaiementCommission",
            key: "datePaiementCommission",
            render: (_, record) => (
                <>{frenchDate(record.dateReglement)} </>
            ),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, record) => (
                <Space size="middle">
                    <Button style={{ background: "purple", color: "white" }} icon={<FilePdfOutlined />} onClick={() => genererBorderau(record)} />

                    {!record?.modePaiementCommission && LOGGED_USER?.agence?.typeAgence === "SIEGE" ?
                        <Button style={{ background: "gold", color: "white" }} icon={<CreditCardOutlined />} onClick={() => encaisserBordereau(record)} /> : null
                    }
                </Space>
            )
        }
    ];

    const genererBorderau = (bord) => {
        if (bord?.reglements.length > 0) {
            setBordereauToPay(bord);
            console.log("Rows selected", bord);
            setOpenModalBorderau(true);
        } else {
            toast("Veuillez choisir un bordereau avec des reglements");
        }
    };

    const encaisserBordereau = (bd) => {
        setModalModePaiement(true);
        setBordereauToPay(bd);
    };

    useEffect(() => {
        let allInt = [];
        axiosInstance
            .get(`/api/bordereau/all/commissions`, {
                params: {
                    page: currentPage - 1,
                    size: pageSize,
                    search: "",
                    startDate: null,
                    endDate: null,
                    compagnie: "",
                },
            })
            .then((res) => {
                // console.log("Bordereaux: ", res.data);
                setBordereaux(res.data);
                setLoadingContrats(false);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/categorie`)
            .then((res) => {
                let cats = [];
                res.data
                    .filter((e) => !e.codeCategorie.startsWith("V"))
                    .forEach((cat) => {
                        cats.push(cat.codeCategorie);
                    });
                setSelectedCategorie(cats);
                setCategories(
                    res.data.filter((e) => !e.codeCategorie.startsWith("V")),
                );
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/intermediaire`)
            .then((res) => {
                // console.log("Res; ", res.data);
                res.data.forEach((int) => {
                    allInt.push(int.codeIntermediaire);
                });
                setIntermediaires(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`api/agence/all/courtiers`)
            .then((res) => {
                // console.log("Agreed courtiers: ", res.data);
                res.data.forEach((ag) => {
                    allInt.push(ag.codeAgence);
                });
                setCourtiers(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setTimeout(() => {
            setSelectedAgence(allInt);
        }, 1000);
    }, []);

    const handleAgenceChange = (agencies) => {
        let filRegs = [];
        agencies.forEach((value) => {
            let inter = intermediaires.find((el) => el.codeIntermediaire === value);
            if (inter) {
                // setSelectedIntermediaire(inter);
                filRegs = allCommissions.filter(
                    (el) => el?.contrat?.intermediaire?.codeIntermediaire === value,
                );
            } else {
                // let ag = courtiers.find(el => el.codeAgence === value);
                filRegs = allCommissions.filter(
                    (el) => el?.contrat?.courtier?.codeAgence === value,
                );
                // setSelectedIntermediaire(ag);
            }
        });

        setSelectedAgence(agencies);
        setCommissions(filRegs);
        // console.log("Commissions: ", filRegs);
        selectedCategorie && categorieFilteringOn(selectedCategorie);
        selectedDate && dateFilteringOn("ok", selectedDate);
    };

    const handleAgenceChangeOn = (agencies) => {
        let filRegs = [];
        agencies.forEach((value) => {
            let inter = intermediaires.find((el) => el.codeIntermediaire === value);
            if (inter) {
                // setSelectedIntermediaire(inter);
                filRegs = commissions.filter(
                    (el) => el?.contrat?.intermediaire?.codeIntermediaire === value,
                );
            } else {
                // let ag = courtiers.find(el => el.codeAgence === value);
                filRegs = commissions.filter(
                    (el) => el?.contrat?.courtier?.codeAgence === value,
                );
                // setSelectedIntermediaire(ag);
            }
        });

        setSelectedAgence(agencies);
        setCommissions(filRegs);
    };

    const dateFiltering = (date, dateString) => {
        setSelectedDate(dateString);
        let filRegs = [];
        if (dateString[0] === dateString[1]) {
            allCommissions.forEach((dt) => {
                isEqualDate(dateString[0], dt.data.createdAt) && filRegs.push(dt);
            });
            setCommissions(filRegs);
        } else {
            allCommissions.forEach((dt) => {
                isBetweenOrEqualDate(dt.data.createdAt, dateString[0], dateString[1]) &&
                    filRegs.push(dt);
            });
            setCommissions(filRegs);
        }

        if (!dateString[0].length && !dateString[1].length) {
            setCommissions(allCommissions);
        }

        selectedCategorie && categorieFilteringOn(selectedCategorie);
        selectedAgence && handleAgenceChangeOn(selectedAgence);
    };

    const dateFilteringOn = (date, dateString) => {
        setSelectedDate(dateString);
        let filRegs = [];
        if (dateString[0] === dateString[1]) {
            commissions.forEach((dt) => {
                isEqualDate(dateString[0], dt.data.createdAt) && filRegs.push(dt);
            });
            setCommissions(filRegs);
        } else {
            commissions.forEach((dt) => {
                isBetweenOrEqualDate(dt.data.createdAt, dateString[0], dateString[1]) &&
                    filRegs.push(dt);
            });
            setCommissions(filRegs);
        }

        if (!dateString[0]?.length && !dateString[1]?.length) {
            setCommissions(commissions);
        }
    };

    const categorieFiltering = (sCategories) => {
        setSelectedCategorie(sCategories);
        let filRegs = [];
        sCategories.forEach((categorie) => {
            if (categorie) {
                filRegs = allCommissions.filter(
                    (el) =>
                        el?.contrat?.engins[0]?.categorie?.codeCategorie === categorie,
                );
            }
        });
        setCommissions(filRegs);
        selectedAgence && handleAgenceChangeOn(selectedAgence);
        selectedDate && dateFilteringOn("ok", selectedDate);
    };

    const categorieFilteringOn = (sCategories) => {
        setSelectedCategorie(sCategories);
        let filRegs = [];
        sCategories.forEach((categorie) => {
            if (categorie) {
                filRegs = commissions.filter(
                    (el) =>
                        el?.contrat?.engins[0]?.categorie?.codeCategorie === categorie,
                );
            }
        });
        setCommissions(filRegs);
    };

    // const printBordereau = () => {
    //     console.log("Printing");
    //     setHidden(true);
    //     handlePrint();
    // };

    const calculateTotals = (reglements) => {
        return reglements?.reduce((acc, reg) => ({
            montant: acc.montant + (reg.montant || 0),
            primeNetteCompagnie: acc.primeNetteCompagnie + (reg.primeNetteCompagnie || 0),
            accessoires: acc.accessoires + (reg.accessoires || 0),
            taxes: acc.taxes + (reg.taxes || 0),
            primeTotale: acc.montant + (reg.montant || 0),
            commission: acc.commission + (reg.commission || 0),
            retenue: acc.retenue + (reg.retenue || 0),
            commissionNette: acc.commissionNette + (reg.commissionNette || 0)
        }), {
            montant: 0,
            primeNetteCompagnie: 0,
            accessoires: 0,
            taxes: 0,
            primeTotale: 0,
            commission: 0,
            retenue: 0,
            commissionNette: 0
        });
    };

    const printBordereau = async (data) => {
        setLoading(true);

        try {

            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const totals = calculateTotals(data?.reglements);

            // Convertir l'entête en base64
            let headerBase64 = null;
            if (DocumentHeader) {
                headerBase64 = await componentToBase64(<DocumentHeader logoPreviewUrl={`data:image/png;base64,${bordereauToPay?.logoDisplay}`} />);
            }

            // Convertir le footer en base64
            let footerBase64 = null;
            if (DocumentFooter) {
                footerBase64 = await componentToBase64(<DocumentFooter />);
            }

            // Fonction pour ajouter header et footer sur chaque page
            const addHeaderFooter = (pageNumber) => {
                // Ajouter l'entête
                if (headerBase64) {
                    const headerHeight = 25; // Hauteur de l'entête en mm
                    doc.addImage(headerBase64, 'PNG', 0, 0, pageWidth, headerHeight);
                }

                // Ajouter le footer
                if (footerBase64) {
                    const footerHeight = 20; // Hauteur du footer en mm
                    const footerY = pageHeight - footerHeight;
                    doc.addImage(footerBase64, 'PNG', 0, footerY, pageWidth, footerHeight);
                }

                // Numéro de page
                doc.setFontSize(8);
                doc.setTextColor(128);
                doc.text(
                    `Page ${pageNumber}`,
                    pageWidth - 20,
                    pageHeight - 5,
                    { align: 'right' }
                );
            };

            // Ajouter header sur la première page
            addHeaderFooter(1);

            // Position de départ du contenu (après l'entête)
            const startY = headerBase64 ? 30 : 15;

            // Titre
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            const title = `BORDEREAU DE COMMISSION N° ${data?.numeroBordereau}`;
            const titleWidth = doc.getTextWidth(title);
            doc.text(title, (pageWidth - titleWidth) / 2, startY);

            // Préparation des données du tableau
            const tableData = data?.reglements.map(reg => [
                reg.contrat?.numeroPoliceP || '',
                reg?.contrat?.souscripteur?.nom + ' ' + (reg?.contrat?.souscripteur?.prenom || '') || '',
                frenchDateOnly(reg.contrat?.dateEffet) || '',
                frenchDateOnly(reg.contrat?.dateEcheance) || '',
                reg.contrat?.categorie || '',
                displayFloorNum(reg.montant),
                displayFloorNum(reg.accessoires),
                displayFloorNum(reg.taxes),
                displayFloorNum(reg.montant),
                reg.tauxCommission ? `${reg.tauxCommission}%` : '',
                displayFloorNum(reg.commission || 0),
                displayFloorNum(reg.retenue || 0),
                displayFloorNum(reg.commissionNette || 0)
            ]);

            // Ligne des totaux
            tableData.push([
                { content: 'Totaux', colSpan: 5, styles: { fontStyle: 'bold', halign: 'center' } },
                { content: displayFloorNum(totals.montant), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.accessoires), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.taxes), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.montant), styles: { fontStyle: 'bold' } },
                '',
                { content: displayFloorNum(totals.commission), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.retenue), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.commissionNette), styles: { fontStyle: 'bold' } }
            ]);
            // Calcul de la marge basse (pour le footer)
            const bottomMargin = footerBase64 ? 25 : 10;
            // Génération du tableau
            autoTable(doc, {
                startY: startY + 5,
                head: [[
                    'N° Police',
                    'Assuré',
                    'Effet',
                    'Échéance',
                    'Catégorie',
                    'Prime nette',
                    'CP',
                    'Taxes',
                    'PTTC',
                    'Taux commissions',
                    'Commissions',
                    'Retenue/C',
                    'Commission nette'
                ]],
                body: tableData,
                theme: 'striped',
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'center',
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center',
                    fontSize: 7
                },
                columnStyles: {
                    0: { cellWidth: 30 }, // N° Police
                    1: { cellWidth: 35, halign: 'left' }, // Assuré
                    2: { cellWidth: 20 }, // Effet
                    3: { cellWidth: 20 }, // Échéance
                    4: { cellWidth: 18 }, // Catégorie
                    5: { cellWidth: 20, halign: 'right' }, // PN Pool
                    6: { cellWidth: 20, halign: 'right' }, // CP
                    7: { cellWidth: 18, halign: 'right' }, // Taxes
                    8: { cellWidth: 20, halign: 'right' }, // PT TC
                    9: { cellWidth: 15 }, // Taux de commission
                    10: { cellWidth: 18, halign: 'right' }, // Commissions
                    11: { cellWidth: 18, halign: 'right' }, // Retenue / Commissions
                    12: { cellWidth: 18, halign: 'right' } // Commission nette
                },
                didParseCell: function (data) {
                    // Style pour la ligne des totaux
                    if (data.row.index === tableData.length - 1) {
                        data.cell.styles.fillColor = [236, 240, 241];
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
                margin: { left: 10, right: 10 },
                didDrawPage: function (data) {
                    // Ajouter header et footer sur chaque nouvelle page
                    if (data.pageNumber > 1) {
                        addHeaderFooter(data.pageNumber);
                    }
                }
            });

            // Pied de page avec signatures
            const finalY = doc.lastAutoTable.finalY + 10;

            // Vérifier s'il y a assez d'espace pour les signatures
            if (finalY + 25 < pageHeight - bottomMargin) {
                doc.setFontSize(10);
                doc.setFont(undefined, 'bold');
                doc.setTextColor(0);

                const signatureY = finalY;
                const signatureLineY = signatureY + 15;

                // Le Courtier
                doc.text('L\'agent', 30, signatureY);
                doc.line(20, signatureLineY, 80, signatureLineY);

                // Le Gestionnaire
                // doc.text('Le Gestionnaire', pageWidth / 2 - 20, signatureY);
                // doc.line(pageWidth / 2 - 30, signatureLineY, pageWidth / 2 + 30, signatureLineY);

                // La Compagnie
                doc.text('La Compagnie', pageWidth - 50, signatureY);
                doc.line(pageWidth - 60, signatureLineY, pageWidth - 20, signatureLineY);
            }

            window.open(doc.output('bloburl'), '_blank');

        } catch (error) {
            console.error('Erreur lors de la génération du PDF:', error);
            alert('Erreur lors de la génération du PDF');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const alertReglementBordereau = (bd) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ce bordereau?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementBordereau(bd);
            },
            onCancel() {
                console.log("Cancel");
            },
        });


    };

    const reglementBordereau = (bd) => {
        axiosInstance
            .put(`/api/bordereau/encaisser`, {
                codeId: bd.codeId,
                modePaiement: modePaiement,
                numeroPaiement: numeroPaiement,
                banque: banque
            })
            .then((resp) => {
                toast("Reglement effectué avec succès!");
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors du règlement");
            });

    };

    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"COURTIERS"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            {/* Your main content here */}
                            <div class="row g-6 mb-6">
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">
                                                        Filtrer suivant la Période
                                                    </span>
                                                    <div class="d-flex align-items-center my-1">
                                                        <RangePicker onChange={dateFiltering} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="align-items-start justify-content-between">
                                                <div class="content">
                                                    <span class="text-heading">
                                                        Filtrer suivant la Catégorie
                                                    </span>
                                                    <div class="align-items-center my-1">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Sélectionner la catégorie......"
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            onChange={categorieFiltering}
                                                            options={categories.map((cat) => ({
                                                                value: cat.codeCategorie,
                                                                label: cat.nom,
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">
                                                        Filtrer suivant l'Intermédiaire
                                                    </span>
                                                    <div class="align-items-center my-1">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Sélectionner l'intermédiaire......"
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            onChange={handleAgenceChange}
                                                            options={[
                                                                {
                                                                    label: <span>Intermédiaire</span>,
                                                                    title: "intermediaire",
                                                                    options: intermediaires?.map((a, id) => ({
                                                                        label: a.personne.nom,
                                                                        value: a.codeIntermediaire,
                                                                        key: id,
                                                                    })),
                                                                },
                                                                {
                                                                    label: <span>Courtier</span>,
                                                                    title: "courtier",
                                                                    options: courtiers?.map((c, id) => ({
                                                                        label: c.nom,
                                                                        value: c.codeAgence,
                                                                        key: id,
                                                                    })),
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">-</span>
                                                    <div class="d-flex align-items-center my-1">-</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-4">
                                <div class="card-datatable table-responsive">
                                    <ConfigProvider locale={frFR}>
                                        <Spin spinning={loadingContrats}>
                                            <Table
                                                columns={columns}
                                                dataSource={bordereaux}
                                                onChange={handleChange}
                                                pagination={{
                                                    current: currentPage,
                                                    pageSize: pageSize,
                                                    total: total,
                                                    showSizeChanger: true,
                                                }}
                                            />
                                        </Spin>
                                    </ConfigProvider>
                                </div>
                                {/* <FloatButton style={{ color: "yellowgreen" }} onClick={() => console.log('onClick')} /> */}
                            </div>
                            {hidden && (
                                <PdfBordereau
                                    ref={printReference}
                                    allCommissions={commissions}
                                    allCategories={selectedCategorie}
                                    allIntermediaires={selectedAgence}
                                />
                            )}
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>
            <Modal
                title="Bordereau de commissions"
                centered
                open={openModalBorderau}
                onOk={() => {
                    console.log("OK");
                    setOpenModalBorderau(false);
                }}
                onCancel={() => {
                    setOpenModalBorderau(false);
                }}
                width={1200}
                zIndex={2000}
            >
                <BorderauCommissions
                    ref={printRecu}
                    bordereau={bordereauToPay}
                />
                <Button
                    type="primary"
                    onClick={() => {
                        printBordereau(bordereauToPay);
                    }}
                    icon={<FilePdfOutlined />}
                    style={{ marginTop: "50px", backgroundColor: "gray" }}
                >
                    Imprimer
                </Button>

            </Modal>
            <Modal
                title="Mode de paiement"
                centered
                open={modalModePaiement}
                onOk={() => {
                    alertReglementBordereau(bordereauToPay);
                }}
                onCancel={() => {
                    setModalModePaiement(false);
                }}
            >
                <>
                    <div className="container" justify="center">
                        <div className="grid-item" lg={12}>
                            <Form
                                form={modePaiementForm}
                                layout="vertical"
                                name="userForm"
                            >
                                <Form.Item
                                    name="modePaiement"
                                    label="Mode de paiement"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        onChange={(value) => {
                                            console.log(value);
                                            setModePaiement(value);
                                        }}
                                        placeholder="Selectionnez votre mode de paiement"
                                    >
                                        <Option value="ESPECES"> ESPECES </Option>
                                        <Option value="BANQUE">BANQUE (Chèque)</Option>
                                        <Option value="MOBILE_MONEY">TMONEY / FLOOZ</Option>
                                    </Select>
                                </Form.Item>
                                {modePaiement === "BANQUE" ||
                                    modePaiement === "MOBILE_MONEY" ? (
                                    <Form.Item
                                        name="numeroPaiement"
                                        label={
                                            modePaiement === "BANQUE"
                                                ? "Numero de chèque"
                                                : modePaiement === "MOBILE_MONEY"
                                                    ? "Numero FLOOZ / TMONEY"
                                                    : ""
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: "Veuillez renseigner le champ!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={
                                                modePaiement === "BANQUE"
                                                    ? "Le numero de chèque"
                                                    : modePaiement === "MOBILE_MONEY"
                                                        ? "Le numero de téléphone MOOV (FLOOZ) / TOGOCOM (TMONEY)"
                                                        : ""
                                            }
                                            onChange={(value) => {
                                                console.log(value.target.value);
                                                setNumeroPaiement(value.target.value);
                                            }}
                                        />
                                    </Form.Item>
                                ) : null}
                                {modePaiement === "BANQUE" ? (
                                    <Form.Item
                                        name="banque"
                                        label="Banque"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Select
                                            onChange={(value) => {
                                                console.log(value);
                                                setBanque(value);
                                            }}
                                            placeholder="Selectionnez la banque"
                                        >
                                            {banques.map((b) => (
                                                <Option
                                                    key={b.parametreId}
                                                    value={b.libelleParametre}
                                                >
                                                    {b.libelleParametre}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                ) : null}
                            </Form>
                        </div>
                    </div>
                </>
            </Modal>
            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>
            <div class="buy-now">
                <button
                    onClick={() => printBordereau(bordereauToPay)}
                    class="btn btn-primary btn-buy-now"
                    disabled
                >
                    Imprimer
                </button>
            </div>
            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default Bordereaux;
